import React from 'react';

/**
 * Placeholder — Core has no module-specific settings yet. Reachable via the
 * gear icon in NavbarTop (settingsActive toggle), not via NavbarBottom —
 * same pattern as Health's tab_settings.
 */
const TabCoreSettings = () => {
  return (
    <div className="bg-white rounded-2xl shadow p-4 text-sm text-gray-500">
      No settings available yet.
    </div>
  );
};

export default TabCoreSettings;
